<div class="d-flex mx-0 flex-column flex-md-row justify-contet-between p-white border-bottom secondaryMenu px-4 py-3">
    <div class="d-flex flex-column col">
        <h3 class="mt-0 mb-1">Create Template</h3>
        <p-breadcrumb [model]="items"></p-breadcrumb>
    </div>
    <div class="d-flex justify-content-start justify-content-md-end col mt-2 mt-md-0">
        <button pButton type="button" label="Discard Request" class="p-button-outlined p-button-danger me-3"></button>
        <button pButton type="button" label="Publish Template" class="p-button-outlined me-3"></button>
        <button pButton type="button" label="Save Template" iconPos="left"></button>
    </div>
</div>

<div class="row mx-0">
    <div class="col-12 col-sm-12 col-md-4 col-lg-3 px-0">
        <div class="m-3 p-white shadow-sm bg-aqua p-3">
            <h4 class="mt-0 mb-4">Template Details</h4>
            <div class="d-flex flex-column mb-4">
                <label class="mb-2">Name</label>
                <input type="text" pInputText> 
            </div>
            <div class="d-flex flex-column mb-4">
                <label class="mb-2">Description</label>
                <textarea rows="5" cols="30" pInputTextarea></textarea>
            </div>
            <div class="d-flex flex-column mb-4">
                <label class="mb-2">Associated Job Type</label>
                <p-dropdown placeholder="Select Job Type" optionLabel="name"></p-dropdown>
            </div>
            <div class="d-flex flex-row align-items-center mb-4">
                <p-inputSwitch [(ngModel)]="checked1"></p-inputSwitch>
                <label class="ms-2">Budget Is Applicable</label>
            </div>
            <div class="d-flex flex-column mb-4">
                <label class="mb-2">Budget Type</label>
                <p-dropdown placeholder="Select Budget Type" optionLabel="name"></p-dropdown>
            </div>
            <div class="d-flex flex-column mb-4">
                <label class="mb-2">Priority</label>
                <p-dropdown placeholder="Select Priority" optionLabel="name"></p-dropdown>
            </div>
        </div>
    </div>
    <div class="col-12 col-sm-12 col-md-4 col-lg-6 px-0">
        <div class="m-3 p-white shadow-sm bg-aqua p-3">
            <div class="mb-3">
                <h4 class="my-0">Template Builder</h4>
            </div>
            <div class="row mb-4">
                <div class="col-12 col-sm-12">
                    <div  pDroppable="products">
                        <p-table [autoLayout]="true"  [value]="products">
                            <ng-template pTemplate="body" let-product let-index="rowIndex">
                                <tr [pReorderableRow]="index" class="bg-light mb-3">
                                    <td class="p-0">
                                        <div class="d-flex align-items-center justify-content-between bg-dark px-3 py-2 templateHeader">
                                            <h5 class="my-2">Field Name</h5>
                                            <span class="pi pi-bars" [pReorderableRowHandle]="index"></span>
                                        </div>
                                        <div>
                                            <div class="p-3">
                                                <div class="row mb-4">
                                                    <div class="col-12 col-sm-12 col-md-6">
                                                        <div class="d-flex flex-column">
                                                            <label class="mb-2">Field Name</label>
                                                            <input type="text" pInputText> 
                                                        </div>
                                                    </div>
                                                    <div class="col-12 col-sm-12 col-md-6">
                                                        <div class="d-flex flex-column">
                                                            <label class="mb-2">Type</label>
                                                            <p-dropdown placeholder="Select Type" optionLabel="name"></p-dropdown>
                                                        </div>
                                                    </div>
                                                </div>
                                                <div class="row mb-4">
                                                    <div class="col-12 col-sm-12 col-md-6">
                                                        <div class="d-flex flex-column">
                                                            <label class="mb-2">Character Limit</label>
                                                            <input type="text" pInputText> 
                                                        </div>
                                                    </div>
                                                    <div class="col-12 col-sm-12 col-md-6">
                                                        <div class="d-flex flex-column">
                                                            <label class="mb-2">Allowed Characters</label>
                                                            <p-dropdown placeholder="Text Input" optionLabel="name"></p-dropdown>
                                                        </div>
                                                    </div>
                                                </div>
                                                <div class="row">
                                                    <div class="col-12 col-sm-12">
                                                        <div class="d-flex flex-row align-items-center mb-4">
                                                            <p-inputSwitch [(ngModel)]="checked1"></p-inputSwitch>
                                                            <label class="ms-2">Budget Is Applicable</label>
                                                        </div>
                                                    </div>
                                                </div>
                                                <div class="row">
                                                    <div class="col-12 col-sm-12">
                                                        <button pButton pRipple type="button" label="Remove Field" class="p-button-outlined p-button-danger me-3"></button>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </td>
                                </tr>
                                <tr>
                                    <td class="py-2"></td>
                                </tr>
                            </ng-template>
                        </p-table>
                    </div>
                </div>
            </div>
        </div>
    </div>

    <div class="col-12 col-sm-12 col-md-4 col-lg-3 px-0">
        <div class="m-3 p-white shadow-sm p-3">
            <h4 class="mt-0 mb-4">Template Permissions</h4>
            <div class="d-flex flex-column mb-4">
                <p-accordion [multiple]="true">
                    <p-accordionTab>
                        <ng-template pTemplate="header">
                            <span>
                                <span class="me-3"><i class="pi pi-chart-line"></i></span>
                                <span>Marketing</span>
                            </span>
                        </ng-template>
                        <ng-template pTemplate="content">
                            <table cellspacing="0">
                                <thead>
                                    <tr>
                                        <th>User Role</th>
                                        <th class="text-center">Allow</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr>
                                        <td>Designers</td>
                                        <td class="text-center"><p-checkbox [(ngModel)]="checked"  inputId="binary"></p-checkbox></td>
                                    </tr>
                                    <tr>
                                        <td>Content Writers</td>
                                        <td class="text-center"><p-checkbox [(ngModel)]="checked"  inputId="binary"></p-checkbox></td>
                                    </tr>
                                    <tr>
                                        <td>Photographers</td>
                                        <td class="text-center"><p-checkbox [(ngModel)]="checked"  inputId="binary"></p-checkbox></td>
                                    </tr>
                                </tbody>
                            </table>
                        </ng-template>
                    </p-accordionTab>
                    <p-accordionTab>
                        <ng-template pTemplate="header">
                            <span>
                                <span class="me-3"><i class="pi pi-dollar"></i></span>
                                <span>Finance</span>
                            </span>
                        </ng-template>
                        <ng-template pTemplate="content">Body Content</ng-template>
                    </p-accordionTab>
                    <p-accordionTab>
                        <ng-template pTemplate="header">
                            <span>
                                <span class="me-3"><i class="pi pi-cog"></i></span>
                                <span>Accounting</span>
                            </span>
                        </ng-template>
                        <ng-template pTemplate="content">Body Content</ng-template>
                    </p-accordionTab>
                </p-accordion>
                
            </div>
            
        </div>
    </div>
</div>
    
